
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Classes`}</h1>
<p>{`Always use classes instead of protoype manipulation.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
function Person(name) {
  this.name = name;
}

Person.prototype.getName = function () {
  return this.name;
};

// Good
class Person {
  constructor(name) {
    this.name = name;
  }

  getName() {
    return this.name;
  }
}
`}</code></pre>
<p>{`It's ok to overwrite `}<inlineCode parentName="p">{`toString()`}</inlineCode>{` method.`}</p>
<pre><code parentName="pre" {...{}}>{`class Person {
  constructor(name) {
    this.name = name;
  }

  toString() {
    return \`Person: \${this.name}\`;
  }
}

const person = new Person('User');
console.log(String(person));  // prints Person: User instead of [object Object]
`}</code></pre>
<p>{`Never use empty constructors.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
class Person {
  constructor() {
  }

  setName(name) {
    this.name = name;
  }

  getName() {
    return this.name;
  }
}

// Good
class Person {
  setName(name) {
    this.name = name;
  }

  getName() {
    return this.name;
  }
}
`}</code></pre>
<p>{`Never have duplicate class members.`}</p>
<blockquote>
<p parentName="blockquote">{`In JavaScript there is no method overloading, so it's mostly a programmer error.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`class Person {
  setName(name) {
    this.name = name;
  }

  setName(name, lastName) {
    this.name = name;
    this.lastName = lastName;
  }
}
`}</code></pre>
<p>{`Always use method shorthand when declaring methods in a class.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
class Person {
  constructor(name) {
    this.name = name;
  }

  getName = () => {
    return this.name;
  };
}

// Good
class Person {
  constructor(name) {
    this.name = name;
  }

  getName() {
    return this.name;
  }
}
`}</code></pre>
<p>{`Always use class fields when declaring initial values for class members.`}</p>
<blockquote>
<p parentName="blockquote">{`It's already at Stage 3 and it's well supported on Babel`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
class Person {
  constructor(name) {
    this.name = name;
    this.role = 'customer';
  }
}

// Good
class Person {
  role = 'customer';

  constructor(name) {
    this.name = name;
  }
}
`}</code></pre>
<p>{`Class fields always come first in a class.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
class Person {
  constructor(name) {
    this.name = name;
  }

  role = 'customer';
}

// Good
class Person {
  role = 'customer';

  constructor(name) {
    this.name = name;
  }
}
`}</code></pre>
<p>{`The `}<inlineCode parentName="p">{`constructor`}</inlineCode>{` always comes before the methods.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
class Person {
  getName() {
    return this.name;
  }

  constructor(name) {
    this.name = name;
  }
}

// Good
class Person {
  constructor(name) {
    this.name = name;
  }

  getName() {
    return this.name;
  }
}
`}</code></pre>
<p>{`Always prefix methods indended for internal use in a class with `}<inlineCode parentName="p">{`_`}</inlineCode>{`.`}</p>
<blockquote>
<p parentName="blockquote">{`This won't prevent them to be accessed from the outside but provides a helpful visual indication to every developer of which methods are expected to be used outside of the class and which methods are just internal.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
class Person {
  constructor(name, lastName) {
    this.name = name;
    this.lastName = lastName;
  }

  getFullName() {
    return this.joinNames();
  }

  joinNames() {
    return \`\${this.name} \${this.lastName}\`;
  }
}

const p = new Person('User', 'Userface');
p.joinNames();  // Should it be used like this?


// Good
class Person {
  constructor(name, lastName) {
    this.name = name;
    this.lastName = lastName;
  }

  getFullName() {
    return this._joinNames();
  }

  _joinNames() {
    return \`\${this.name} \${this.lastName}\`;
  }
}

const p = new Person('User', 'Userface');
p._joinNames();  // We shouldn't be using this method like this
`}</code></pre>
<p>{`Never include pure functions as methods of a class. Extract them as a module function instead.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? This makes clearer that the function is indeed not depending on any internal value of the class.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
class Person {
  constructor(name, lastName) {
    this.name = name;
    this.lastName = lastName;
  }

  getFullName() {
    return this._joinNames(name, lastName);
  }

  _joinNames(name, lastName) {
    return \`\${name} \${lastName}\`;
  }
}

// Good
function _joinNames(name, lastName) {
  return \`\${name} \${lastName};
}

class Person {
  constructor(name, lastName) {
    this.name = name;
    this.lastName = lastName;
  }

  getFullName() {
    return _joinNames(name, lastName);
  }
}
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;